<script lang="ts">
  import type { SwiperOptions } from 'swiper/types';
  import ExtraSwiper from '../components/ExtraSwiper.svelte';
  import { getCMSComponentsFromHybrisAsync } from '../services/hybris';
  import ExtraStoriesThumbnailComponent from './ExtraStoriesThumbnailComponent.svelte';
  import StoryThumbnailSlideTemplate from './StoryThumbnailSlideTemplate.svelte';

  export let metaData;

  let storiesDialog;
  let storiesMetaData = [];
  const swiperOptions = getSwiperOptions();

  function getSwiperOptions(): SwiperOptions {
    return {
      slidesPerView: 'auto',
      spaceBetween: 16,
    };
  }

  export function onLoad() {
    const { extraStoriesThumbnailComponents } = metaData;
    if (extraStoriesThumbnailComponents?.length > 0) {
      const storyUids = extraStoriesThumbnailComponents.split(' ').filter(x => !!x);
      getCMSComponentsFromHybrisAsync(storyUids).then(r => {
        storiesMetaData = r.component || [];
      });
    }
  }
  function onStoryThumbnailClick(e) {
    const { detail: startingIndex } = e;
    storiesDialog.showFullscreen(startingIndex);
  }
</script>

<section class="extra-stories-component-container">
  {#if storiesMetaData?.length > 0}
    <ExtraSwiper
      slidesData={storiesMetaData}
      slideTemplate={StoryThumbnailSlideTemplate}
      {swiperOptions}
      swiperClass="external-links-swiper"
      on:click={onStoryThumbnailClick}
    />
    <ExtraStoriesThumbnailComponent
      stories={storiesMetaData}
      mediaDisplayTime={+metaData.mediaDisplayTime}
      bind:this={storiesDialog}
    />
  {/if}
</section>

<style lang="scss">
  .extra-stories-component-container {
    padding: 16px;
  }
</style>
